export type NavItem = {
  label: string;
  path: string;
  type?: string;
  icon?: string;
  desc?: string;
  nav?: 'hide' | 'show';
  subLinks?: NavItem[];
  childSublinks?: NavItem[];
};

export const navItems: NavItem[] = [
  {
    label: 'Home',
    path: '/',
    nav: 'hide',
    desc: '',
  },
  {
    label: 'Our Approach',
    path: '/our-approach',
    desc: 'How we deliver compliant, cutting-edge data solutions',
    subLinks: [
      {
        label: 'Our Capabilities',
        path: '/our-approach/our-capabilities',
        icon: 'list_alt',
        type: 'group',
      },
      {
        label: 'Data Governance & Compliance',
        path: '/our-approach/data-governance-and-compliance',
        icon: 'assured_workload',
        type: 'group',
      },
      {
        label: 'Innovation Research & Development',
        path: '/our-approach/innovation-research-and-development',
        icon: 'construction',
        type: 'group',
      },
    ],
  },
  {
    label: 'Innovation',
    path: '/innovation',
    subLinks: [
      {
        label: 'Curo46®',
        path: '/innovation/curo46',
        icon: 'query_stats',
        type: 'group',
      },
      {
        label: 'CuroSygnal™',
        path: '/innovation/curosygnal',
        icon: 'monitor_heart',
        type: 'group',
      },
      {
        label: 'SYN46™',
        path: '/innovation/syn46',
        icon: 'query_stats',
        type: 'group',
      },
      {
        label: 'EdTech and Professional Development',
        path: '/innovation/edtech-and-professional-development',
        icon: 'local_library',
        type: 'group',
      },
      {
        label: 'NAICS Codes',
        path: '/innovation/naics-codes',
        icon: 'checklist_rtl',
        type: 'group',
      },
    ],
  },
  {
    label: 'Industries',
    path: '/industries',
    subLinks: [
      {
        label: 'Government',
        path: '/industries/government',
        icon: 'account_balance',
        type: 'group',
        childSublinks: [
          {
            label: 'National Security',
            path: '/industries/government/national-security',
            icon: 'assured_workload',
            type: 'child',
          },
          {
            label: 'Bioinformatics',
            path: '/industries/government/bioinformatics',
            icon: 'biotech',
            type: 'child',
          },
          {
            label: 'Public Health and Policy',
            path: '/industries/government/public-health-and-policy',
            icon: 'ecg',
            type: 'child',
          },
          {
            label: 'Public Sector Solutions',
            path: '/industries/government/public-sector-solutions',
            icon: 'verified_user',
            type: 'child',
          },
        ],
      },
      {
        label: 'Commercial',
        path: '/industries/commercial',
        icon: 'location_city',
        type: 'group',
        childSublinks: [
          {
            label: 'Researchers',
            path: '/industries/commercial/researchers',
            icon: 'menu_book',
            type: 'child',
          },
          {
            label: 'Insurance and Payers',
            path: '/industries/commercial/insurance-and-payers',
            icon: 'send_money',
            type: 'child',
          },
          {
            label: 'Pharmaceuticals',
            path: '/industries/commercial/pharmaceuticals',
            icon: 'vaccines',
            type: 'child',
          },
          {
            label: 'Custom Informatics',
            path: '/industries/commercial/custom-informatics',
            icon: 'tune',
            type: 'child',
          },
          {
            label: 'Sports Medicine',
            path: '/industries/commercial/sports-medicine',
            icon: 'tune',
            type: 'child',
          },
        ],
      },
    ],
  },
  {
    label: 'Data Portal',
    path: '/data-portal',
    // subLinks: [
    //   {
    //     label: "How It Works",
    //     path: "/data-portal/how-it-works",
    //     icon: "quiz",
    //     type: "group",
    //   },
    // ],
  },
  {
    label: 'About Us',
    path: '/about-us',
    subLinks: [
      {
        label: 'Media',
        path: '/about-us/media',
        icon: 'newspaper',
        type: 'group',
      },
      {
        label: 'Careers',
        path: '/about-us/careers',
        icon: 'group',
        type: 'group',
      },
    ],
  },
];

export type FooterItem = {
  label: string;
  path: string;
  type?: string;
  icon?: string;
  desc?: string;
  nav?: 'hide' | 'show'; // Optional property for visibility
  subLinks?: NavItem[]; // Recursive type for nested links
};

export const footerItems: FooterItem[] = [
  {
    label: 'Home',
    path: '/',
    nav: 'hide',
    desc: '',
  },
  {
    label: 'Our Approach',
    path: '/our-approach',
    desc: 'How we deliver compliant, cutting-edge data solutions',
    subLinks: [
      {
        label: 'Our Capabilities',
        path: '/our-approach/our-capabilities',
        type: 'child',
        icon: 'list_alt',
        desc: 'Comprehensive solutions tailored to government and commercial needs.',
      },
      {
        label: 'Data Governance & Compliance',
        path: '/our-approach/data-governance-and-compliance',
        type: 'child',
        icon: 'assured_workload',
        desc: 'Ensuring data privacy and regulatory adherence in all solutions.',
      },
      {
        label: 'Innovation Research & Development',
        path: '/our-approach/innovation-research-and-development',
        type: 'child',
        icon: 'construction',
        desc: 'Advancing AI and bioinformatics for impactful solutions.',
      },
    ],
  },
  {
    label: 'Innovation',
    path: '/innovation',
    desc: 'Driving breakthroughs with AI, synthetic data (SYN46™), and custom solutions.',
    subLinks: [
      {
        label: 'Curo46®',
        path: '/innovation/curo46',
        type: 'child',
        icon: 'query_stats',
        desc: 'Revolutionary AI platform for predictive health risk management.',
      },
      {
        label: 'CuroSygnal™',
        path: '/innovation/curosygnal',
        type: 'child',
        icon: 'monitor_heart',
        desc: 'Explainable AI risk platform for skilled nursing and post-acute care teams.',
      },
      {
        label: 'SYN46™',
        path: '/innovation/syn46',
        type: 'child',
        icon: 'query_stats',
        desc: 'Predictive healthcare with virtual patient models and insights.',
      },
      {
        label: 'EdTech and Professional Development',
        path: '/innovation/edtech-and-professional-development',
        type: 'child',
        icon: 'local_library',
        desc: 'Training programs in AI and bioinformatics for workforce advancement.',
      },
      {
        label: 'NAICS Codes',
        path: '/innovation/naics-codes',
        type: 'child',
        icon: 'tv_options_edit_channels',
        desc: 'Explore our specialized services aligned with industry standards.',
      },
    ],
  },
  {
    label: 'Industries',
    path: '/industries',
    desc: 'Advanced analytics tailored for government and commercial industries',
    subLinks: [
      {
        label: 'Government',
        path: '/industries/government',
        type: 'group',
        icon: 'account_balance',
        desc: 'Data-driven solutions supporting federal, state, and local agencies.',
      },
      {
        label: 'National Security',
        path: '/industries/government/national-security',
        type: 'child',
        icon: 'assured_workload',
        desc: 'AI-driven solutions to protect national security interests.',
      },
      {
        label: 'Bioinformatics',
        path: '/industries/government/bioinformatics',
        type: 'child',
        icon: 'biotech',
        desc: 'Advanced bioinformatics for interpreting complex biological data.',
      },
      {
        label: 'Public Health and Policy',
        path: '/industries/government/public-health-and-policy',
        type: 'child',
        icon: 'ecg',
        desc: 'Data insights for public health initiatives and policy decisions.',
      },
      {
        label: 'Public Sector Solutions',
        path: '/industries/government/public-sector-solutions',
        type: 'child',
        icon: 'verified_user',
        desc: 'Compliant data services tailored for public sector needs.',
      },
      {
        label: 'Commercial',
        path: '/industries/commercial',
        type: 'group',
        icon: 'location_city',
        desc: 'Scalable data solutions for diverse commercial applications.',
      },
      {
        label: 'Researchers',
        path: '/industries/commercial/researchers',
        type: 'child',
        icon: 'menu_book',
        desc: 'Empowering research with data for scientific discovery.',
      },
      {
        label: 'Insurance and Payers',
        path: '/industries/commercial/insurance-and-payers',
        type: 'child',
        icon: 'send_money',
        desc: 'Data insights for enhanced payer and insurance operations.',
      },
      {
        label: 'Pharmaceuticals',
        path: '/industries/commercial/pharmaceuticals',
        type: 'child',
        icon: 'vaccines',
        desc: 'AI-powered data solutions for pharmaceutical innovation.',
      },
      {
        label: 'Custom Informatics',
        path: '/industries/commercial/custom-informatics',
        type: 'child',
        icon: 'tune',
        desc: 'Personalized analytics for impactful, data-driven business solutions.',
      },
      {
        label: 'Sports Medicine',
        path: '/industries/commercial/sports-medicine',
        type: 'child',
        icon: 'tune',
        desc: 'AI-driven performance, injury prevention, and athlete recovery.',
      },
    ],
  },
  {
    label: 'Data Portal',
    path: '/data-portal',
    desc: 'Access synthetic and de-identified data through our secure portal',
    type: 'group',
    // subLinks: [
    //   {
    //     label: "How It Works",
    //     path: "/data-portal/how-it-works",
    //     type: "child",
    //     icon: "quiz",
    //     desc: "Understand the process of accessing tailored data solutions.",
    //   },
    // ],
  },
  {
    label: 'About Us',
    path: '/about-us',
    desc: 'Discover our journey in bioscience innovation and AI solutions.',
    subLinks: [
      {
        label: 'Media',
        path: '/about-us/media',
        type: 'child',
        icon: 'newspaper',
        desc: 'News, videos, and updates from General Genomics.',
      },
      {
        label: 'Careers',
        path: '/about-us/careers',
        type: 'child',
        icon: 'group',
        desc: 'Join our team advancing AI-driven bioscience and data solutions.',
      },
    ],
  },
];
